import { render, staticRenderFns } from "./Myhome.vue?vue&type=template&id=473d080a&"
import script from "./Myhome.vue?vue&type=script&lang=js&"
export * from "./Myhome.vue?vue&type=script&lang=js&"
import style0 from "./Myhome.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports